import {
    Directive,
    ElementRef,
    forwardRef, Host,
    HostListener, Inject, Injector,
    Input,
    OnDestroy,
    OnInit, Optional,
    Renderer2,
    Self
} from '@angular/core';
import {
    ControlContainer,
    ControlValueAccessor,
    FormControl, FormControlDirective,
    FormControlName, FormGroupDirective,
    NG_VALUE_ACCESSOR,
    NgControl,
    NgModel
} from '@angular/forms';
import {Subscription, takeUntil, tap} from "rxjs";

@Directive({
    selector: '[toUppercase]',
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => ToUppercaseDirective),
        multi: true
    }]
})
export class ToUppercaseDirective implements ControlValueAccessor, OnInit, OnDestroy {
    valueSubscription: Subscription;
    private onChange: (val: string) => void;
    private onTouched: () => void;
    @Input() toUppercase: string;
    constructor(
        private elementRef: ElementRef,
        private renderer: Renderer2,

    ) {

    }
    ngOnInit(): void {}
    @HostListener("ngModelChange", ["$event"])
    onNgModelChange(event: string) {
        this.transform(event)
    }

    @HostListener('input', ['$event.target.value'])
    onInputChange(value: string) {
        const newVal = this.transform(value)
        this.updateTextInput(newVal);
        this.onChange(newVal);
    }

    transform(value: string) {
        value = value?.toLocaleUpperCase('TR')
        if (this.toUppercase == 'removeNumber') {
            value = value?.replace(/[0-9]+/g, '');
        }
        return value
    }

    @HostListener('blur')
    onBlur() {
        this.onTouched();
    }

    private updateTextInput(value: string) {
        this.renderer.setProperty(this.elementRef.nativeElement, 'value', value);
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.renderer.setProperty(this.elementRef.nativeElement, 'disabled', isDisabled);
    }

    writeValue(value: any): void {
        if (value == null) {
            value = ''
        }
        this.updateTextInput(value);
    }

    ngOnDestroy(): void {
    }
}
